import request from "@utils/request";

import url from "@utils/url";

const { HOST } = url;

/**
 *
 * @param {Object} params
 * @param {String} params.start 开始时间 YYYYMMDD
 * @param {String} params.end 结束时间 YYYYMMDD
 * @param {String[]} params.gameId 游戏ID列表
 * @param {String | undefined} params.system 系统类型 ios/android
 * @param {String | undefined} params.channel 一级渠道Id
 * @param {String | undefined} params.subChannel 二级渠道Id
 * @param {String[] | undefined} params.thirdChannels 三级渠道ID列表
 * @param {String | undefined} params.customDimension 自定义维度筛选
 * @returns {Promise<{data: {data: Object[], meta: Object}}>}
 * 示例返回：
 */
export async function getStatisticsByDate(params) {
  const url = `${HOST}/cps-gateway/api/v1/newStat/cps/info/date`;
  return request({ method: "post", url: url, noLoading: true }, params);
}

/**
 * @param {Object} params
 * @param {String} params.start 开始时间 YYYYMMDD
 * @param {String} params.end 结束时间 YYYYMMDD
 * @param {String[]} params.gameId 游戏ID列表
 * @param {String | undefined} params.system 系统类型 ios/android
 * @param {String | undefined} params.channel 一级渠道Id
 * @param {String | undefined} params.subChannel 二级渠道Id
 * @param {String[] | undefined} params.thirdChannels 三级渠道ID列表
 * @param {String | undefined} params.customDimension 自定义维度筛选
 * @returns {Promise<{data: {data: Object[], meta: Object}}>}
 */
export async function getStatisticsByChannel(params) {
  const url = `${HOST}/cps-gateway/api/v1/newStat/cps/info/channel`;
  return request({ method: "post", url: url, noLoading: true }, params);
}

